// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__PzDX5","modalFooterButton":"ModalNotes_modalFooterButton__1DKg-"};